import React, { FC, memo } from 'react'
import { LineParam } from '@ucheba/ui/components/LineParam/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { IRatesItemProps } from '../types'

const InstitutionRatesItem: FC<IRatesItemProps> = ({
  institutionLabel,
  postfix,
  title,
  subtitle,
  current,
  average,
  maximum,
  isLocked,
  onLockIconClick,
}) => (
  <div>
    <Heading h3={title} spacing='uxsmall' />

    <Text color='gray60' fontSize='small1'>
      {subtitle}
    </Text>

    <Spacing spacing='xxsmall' />

    <LineParam
      postfix={postfix}
      label={institutionLabel}
      fontWeight='semibold'
      minValue={0}
      maxValue={maximum}
      currentMinValue={0}
      currentMaxValue={current}
      isLocked={isLocked}
      onLockIconClick={onLockIconClick}
    />

    <Spacing spacing='xxsmall' />

    <LineParam
      postfix={postfix}
      label='В среднем по стране'
      fontWeight='medium'
      minValue={0}
      maxValue={maximum}
      currentMinValue={0}
      currentMaxValue={average}
      isLocked={isLocked}
      color='gray25'
      onLockIconClick={onLockIconClick}
    />
  </div>
)

export default memo(InstitutionRatesItem)
